import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavigationItem, SELLER_NAVIGATION, BUYER_NAVIGATION, PARTNER_NAVIGATION } from '../data/navigation.data';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private navigationSubject = new BehaviorSubject<NavigationItem[]>(SELLER_NAVIGATION);
  public navigation$: Observable<NavigationItem[]> = this.navigationSubject.asObservable();

  constructor() {}

  setNavigationByUserType(userType: string): void {
    let navigation: NavigationItem[] = [];

    switch (userType) {
      case 'SELLER':
        navigation = SELLER_NAVIGATION;
        break;
      case 'BUYER':
        navigation = BUYER_NAVIGATION;
        break;
      case 'PARTNER':
      case 'PARTNER_BRANCH_MASTER':
      case 'PARTNER_AGENT':
        navigation = PARTNER_NAVIGATION;
        break;
      default:
        navigation = SELLER_NAVIGATION;
    }

    this.navigationSubject.next(navigation);
    console.log('Navigation set for user type:', userType, navigation);
  }

  getCurrentNavigation(): NavigationItem[] {
    return this.navigationSubject.value;
  }
}